import { createFileRoute } from "@tanstack/react-router";
import z from "zod";

import { SuccessfulPayment } from "@/features/my/checkout/_components/successfull-payment";

export const Route = createFileRoute(
  "/(member)/(protected)/my/checkout/success",
)({
  component: SuccessfulPayment,
  validateSearch: z.object({
    purchaseIntentId: z.string().optional(),
    referId: z.string().optional(),
    referredBy: z.string().optional(),
  }),
});
